import { useOrgAuthStore } from "@solomon-apps/shared";
import React from "react";
import { Navigate } from "react-router-dom";

interface AuthGuardProps {
    children: React.ReactNode;
}

export function AuthGuard({ children }: AuthGuardProps): React.ReactElement {
    const tokens = useOrgAuthStore((s) => s.tokens);

    if (!tokens || tokens.expiresAt < Date.now() + 30_000) {
        return <Navigate to="/login" replace />;
    }

    return <>{children}</>;
}
